import request from '../utils/request';

/**
 * 发送邮件
 * /Mail/contactUs
 */
export function contactUs(form) {
    return request({
        url: '/Mail/contactUs',
        method: 'post',
        data: form
    })
}